import Tdg_ContactDetailsModelBase from '../_generated/modelBases/tdg-contact-details-model-base';

export default class Tdg_ContactDetailsModel extends Tdg_ContactDetailsModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
